import { isBrandRefreshEnabled } from '../../../shared/utilities/brandRefresh';

/** Brand-refresh header UI only when REACT_APP_BRAND_REFRESH_ENABLED === 'true'. */
export const isFullScreenHomepageHeaderBrandRefresh = () =>
  isBrandRefreshEnabled();

/** data-region value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getHeaderRegionProps = () =>
  isBrandRefreshEnabled() ? 'fullscreen-homepage-header' : undefined;

/** data-part value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getHeaderPartProps = (part) =>
  isBrandRefreshEnabled() ? part : undefined;

/**
 * Homepage marker — enables Figma Overlayer (::after gradient) when brand refresh is on.
 * Only on fullscreen homepage (same gate as NavigationBar onHomepage).
 */
export const getHeaderHomepageProps = (isOnHomepage) =>
  isBrandRefreshEnabled() && isOnHomepage ? 'true' : undefined;
